module.exports = __webpack_public_path__ + "media/src/Quiz/sandbox/teaserDemoImage-8bfea976fa97e04af906b19502aa89e9.png";